import { render, staticRenderFns } from "./f2g-dialogLoader.vue?vue&type=template&id=391f83c4"
import script from "./f2g-dialogLoader.vue?vue&type=script&lang=js"
export * from "./f2g-dialogLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports